import { isComponentFor } from 'Shared/resolve-component';
export default (state) => {
    return componentIsSupplierAdPage(state.currentPage.componentName);
};
export function componentIsSupplierAdPage(componentName) {
    return isComponentFor(componentName, "Avensia.Shop.Features.Ad.Pages.SupplierAd.SupplierAdPageViewModel");
}
